import { ReactNode } from 'react';
import { useBreakpoints } from '../../../../../../bookings/util/useBreakpoints';
import {
  CardLeftColumn,
  CardRightColumn,
  PracticeDetailsWrapper,
  PracticeDetailsSection,
  TopSection,
} from '../card.styles';
import { TagWrap } from '../details/PracticeDetails/PracticeDetails.styles';

interface LayoutProps {
  specialties: ReactNode;
  guts: ReactNode;
  tags: ReactNode[];
  logo?: ReactNode;
  practiceDetails: ReactNode;
}

export const Layout = ({ guts, logo, tags, practiceDetails }: LayoutProps) => {
  const isMobile = useBreakpoints().Small;

  if (!isMobile) {
    return (
      <TopSection>
        <CardLeftColumn>
          {guts}
          <TagWrap>{tags}</TagWrap>

          <PracticeDetailsSection>
            <PracticeDetailsWrapper>{practiceDetails}</PracticeDetailsWrapper>
          </PracticeDetailsSection>
        </CardLeftColumn>
        <CardRightColumn>{logo}</CardRightColumn>
      </TopSection>
    );
  }

  return (
    <>
      <TopSection>
        <CardLeftColumn>
          {guts}
          <TagWrap>{tags}</TagWrap>
        </CardLeftColumn>
        <CardRightColumn>{logo}</CardRightColumn>
      </TopSection>

      <PracticeDetailsSection>
        <PracticeDetailsWrapper>{practiceDetails}</PracticeDetailsWrapper>
      </PracticeDetailsSection>
    </>
  );
};
